import { createContext, type ReactNode, useContext } from "react";

export type KioskTheme = "default" | "brand";

interface KioskThemeContextValue {
	theme: KioskTheme;
}

const KioskThemeContext = createContext<KioskThemeContextValue>({
	theme: "brand",
});

const themeAccentMap: Record<KioskTheme, string> = {
	default: "#18e88a",
	brand: "#3789FF",
};

interface KioskThemeProviderProps {
	theme?: KioskTheme;
	children: ReactNode;
}

export const KioskThemeProvider = ({
	theme = "brand",
	children,
}: KioskThemeProviderProps) => {
	return (
		<KioskThemeContext.Provider value={{ theme }}>
			<div
				style={
					{ "--kiosk-accent": themeAccentMap[theme] } as React.CSSProperties
				}
			>
				{children}
			</div>
		</KioskThemeContext.Provider>
	);
};

export const useKioskTheme = () => useContext(KioskThemeContext);
